// @flow

import Tab from './Tab.ui';

export default Tab;
